export const base_url = "https://n7nc6faf8g.execute-api.us-east-2.amazonaws.com/dev/api/";
export const wss_url = "wss://c6224onyn8.execute-api.us-east-2.amazonaws.com/production/"
// export const base_url = process.env.REACT_APP_BASE_URL;

